export const SHARE = {
    /**
     * 分享 data对象
     *  title: '',
     *  text: memberCouponResponse.shareContent,
     *  images: memberCouponResponse.shareImage,
     *  shareTypes: isIos() ? ['wechat', 'moments'] : '[wechat,moments]', // 分享类型
     *  url,
     */
    SHARE: 'share/share',
    // 分享法宝
    SHARE_ITEM: 'share/couponItem', // 分享
};

// 发票协议地址
export const INVOICE = {
    SAVE_INVOICE: 'invoice/save', // 保存发票
    CHOOSE_INVOICE: 'invoice/choose', // 选择发票
};

// 个人信息协议地址
export const USER = {
    LOGIN: 'user/login', // 登录
    LOGOUT: 'user/logout', // 登出
    TOKEN_AND_LOGIN: 'user/tokenAndLogin', // 获取token，如果没有则登录
    TOKEN: 'user/token', // 获取token
    REMOVE_CACHE: 'cache/removecache', // 清除app端缓存的方法
    FILL_USER_NAME_IN_BOOKING: 'user/fillUserNameInBooking', // 补充个人信息
    IDCARD_BACK_TO_USER: 'user/identityNumberAndBack', // 修改身份证信息返回个人中心
    UPDATE_ALPHA: 'common/updateAlpha',
};

// 页面相关协议地址
export const PAGE = {
    JUMP_TO_PAGE: 'page/jumpToWhere', // 跳转app的任意页面
    OPEN_NEWPAGE: 'open/newpage', // 打开新页面
    CLOSE_PAGE: 'page/close', // 关闭当前H5
    BACK_PAGE: 'open/backpage', // 返回
    JUMP_TO_HOTELLIST: 'hotellist', // 跳转app的酒店列表页
    USERGIFTPACKAGE: 'usergiftpackage', // 跳转native 我的礼包
    LOCATION: 'location/location', // 获取定位信息(ios只有2.8.0以后的版本才能使用)
    OPENPAY: 'pay/openPay', // 打开支付
    OPENPAYNEW: 'user/launchMiddlePlatform', // 打开支付
    JUMP_TO_HOTELDETAILS: 'hoteldetails', // 酒店详情
    JUMP_TO_NEW_HOTELLIST: 'hotel/hotelList', // 新酒店列表
};

// 订单相关
export const ORDER = {
    ORDER: 'userOrder',
    CANCEL_ORDER_SUCCESS: 'order/cancelSuccess',
    // 有赞
    YOUZAN: 'youzan',
};
// 上传相关
export const UPLOAD = {
    PHOTO: 'photo/library',
    INDEMNITY: 'photo/indemnity',
};

// app通用方法
export const ATOURLIFE = {
    COMMON_TIP: 'common/tip', // 提示类型：error(错误)/success(成功) == { "type": 'error', "tip": "msg" }
};

export default {
    ...SHARE, // 分享相关
    ...INVOICE, // 发票相关
    ...PAGE, // 页面相关
    ...USER, // 用户信息相关
    ...ORDER, // 订单
    ...UPLOAD,
    ...ATOURLIFE,
};
